<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-button @click="$router.push('/gallery')">back</md-button>
      <md-dialog class="media_dialog" :md-active.sync="showDialog">
        <md-dialog-title>Create a new Gallery</md-dialog-title>

        <md-tabs class="tabs" md-dynamic-height>
          <md-tab md-label="Media Library">
            <div class="dialog-table">
              <md-table
                :value="libraryTableData"
                md-card
                @md-selected="onSelect"
              >
                <md-table-toolbar>
                  <h1 class="md-title">Select from Media Library</h1>
                </md-table-toolbar>

                <md-table-toolbar
                  slot="md-table-alternate-header"
                  slot-scope="{ count }"
                >
                  <div class="md-toolbar-section-start">
                    {{ getAlternateLabel(count) }}
                  </div>
                  <md-button @click="addMultipleMedia">Add</md-button>
                </md-table-toolbar>

                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="multiple"
                  md-auto-select
                  :md-disabled="checkIfItemExist(item)"
                >
                  <md-table-cell md-label="Icon">
                    <md-button
                      class="md-just-icon md-warning md-simple"
                      @click.native="openLink(item.url)"
                    >
                      <md-icon>image</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell md-label="Name" md-sort-by="name">{{
                    item.name
                  }}</md-table-cell>
                  <md-table-cell md-label="Date" md-sort-by="date">{{
                    item.date | format_date
                  }}</md-table-cell>
                  <md-table-cell md-label="Tags" md-sort-by="tags">
                    <md-chip v-for="(tag, i) in item.tags" :key="i">{{
                      tag.text
                    }}</md-chip>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </md-tab>

          <md-tab md-label="Storage">
            <template>
              <Upload
                @uploadImage="addMedia"
                directory="Gallery"
                :media="media.url"
              />
              <label>Add Tags</label>
              <md-field>
                <label>Tags</label>
                <md-chips
                  v-model="media.tags"
                  md-placeholder="Add keyword...(Press Enter To Add)"
                ></md-chips>
              </md-field>
            </template>
            <md-dialog-actions>
              <md-button class="md-primary" @click="save">Submit</md-button>
              <md-button class="md-primary" @click="showDialog = false"
                >Close</md-button
              >
            </md-dialog-actions>
          </md-tab>
        </md-tabs>
      </md-dialog>
      <md-card style="padding: 10px 20px 10px 20px;">
        <md-dialog-title>Image arrangement</md-dialog-title>
        <md-card-content>
          <draggable
            @change="save()"
            v-model="gallery.media_collection"
            @start="drag = true"
            @end="drag = false"
          >
            <transition-group class="gallery-disp">
              <div
                style="cursor:pointer; display:flex; flex-direction: column;"
                v-for="(element, index) in gallery.media_collection"
                :key="index"
              >
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(element)"
                >
                  <md-icon>close</md-icon>
                </md-button>
                <p>{{ element.name }}</p>
                <pdf
                  v-if="element.type && element.type.includes('pdf')"
                  class="pdf-renderer"
                  :src="element.url"
                  style="display: inline-block; width: 25%, "
                ></pdf>
                <video
                  :style="{ maxHeight: '100px' }"
                  v-else-if="element.type && element.type.includes('video')"
                  autoplay
                  :src="element.url"
                ></video>

                <img
                  v-else
                  :style="{ maxHeight: '100px' }"
                  :src="element.url"
                />

                <p>Order: {{ (index += 1) }}</p>
              </div>
            </transition-group>
          </draggable>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button
            class="md-primary md-round md-small"
            @click="showDialog = true"
            >Add Image</md-button
          >
        </md-card-actions>
      </md-card>
      <md-card>
        <md-dialog-title>Gallery setup</md-dialog-title>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="gallery.title" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Slide Transaction Time</label>
            <md-input v-model="gallery.speed" type="number"></md-input>
          </md-field>

          <p>Slide Direction</p>
          <md-checkbox v-model="gallery.autoplayDirection" value="forward"
            >Left</md-checkbox
          >
          <md-checkbox v-model="gallery.autoplayDirection" value="backward"
            >Right</md-checkbox
          >

          <md-field>
            <label>Media Player</label>
            <md-select multiple v-model="gallery.kiosks">
              <md-option value="none">None</md-option>
              <md-option
                v-for="kiosk in kiosks"
                :value="kiosk.id"
                :key="kiosk.id"
                >{{ kiosk.name }}</md-option
              >
            </md-select>
          </md-field>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button class="md-primary md-round md-small" @click="validate"
            >Save</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import router from "@/router";
import Upload from "@/components/Inputs/Upload.vue";
import draggable from "vuedraggable";
import pdf from "vue-pdf";

export default {
  components: {
    draggable,
    Upload,
    pdf
  },
  data() {
    return {
      clients: null,
      showDialog: false,
      libraryTableData: [],
      kiosks: null,
      gallery: {
        title: null,
        media_collection: [],
        speed: 1,
        kiosks: [],
        autoplayDirection: "forward"
      },
      selected: [],
      media: {
        url: null,
        name: null,
        size: null,
        date: null,
        usage_count: null,
        private: null,
        tags: []
      }
    };
  },
  watch: {},
  firestore() {
    return {
      gallery: db.collection("gallery").doc(this.$route.params.gallery_id),
      libraryTableData: db.collection("media_library"),
      kiosks: db.collection("kiosks")
    };
  },

  methods: {
    checkIfItemExist(item) {
      return this.gallery.media_collection.find(m => m.name == item.name)
        ? true
        : false;
    },
    addMedia(media) {
      this.media = Object.assign(this.media, media);
      this.gallery.media_collection.push(this.media);
      this.save();
    },
    addMultipleMedia() {
      this.gallery.media_collection.push(...this.selected);
      this.selected = [];
      this.save();
    },

    updatePrivacy(item) {
      db.collection("gallery")
        .doc(item.id)
        .update({ private: item.private });
    },

    submit() {
      let media_libraryRef = db.collection("media_library").doc();
      let ref = db.collection("gallery").doc(this.$route.params.gallery_id);

      this.gallery.media_collection.push(this.media);
      ref
        .set(this.gallery, { merge: true })
        .then(() => {
          media_libraryRef.set(this.media);
        })
        .then(() => {
          this.media = {
            url: null,
            name: null,
            size: null,
            date: null,
            usage_count: null,
            tags: []
          };
        })
        .then(() => {
          return Swal.fire(
            "Success",
            "Your file has been uploaded!",
            "success"
          );
        })
        .catch(err => {
          return Swal.fire(
            "Error",
            "Your file couldn't be uploaded, Try again later",
            "warning"
          );
        });
    },
    showImage(item) {
      let id = item.id;
    },
    onSelect(items) {
      this.selected = items;
    },
    getAlternateLabel(count) {
      let plural = "";

      if (count > 1) {
        plural = "s";
      }

      return `${count} user${plural} selected`;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          let media_collection = this.gallery.media_collection.filter(
            image => image.url !== item.url
          );
          return db
            .collection("gallery")
            .doc(this.gallery.id)
            .update({
              media_collection: media_collection
            })
            .then(() => {
              Swal.fire("Deleted!", "The image has been deleted.", "success");
            });
        }
      });
    },
    validate() {
      let valid = true;
      for (let k in this.gallery) {
        if (!this.gallery[k]) {
          if (this.gallery[k] < 0) {
            valid = false;
          }
        }
      }

      if (valid) {
        this.save();
      } else {
        alert("Please fill in all fields");
      }
    },
    save() {
      let vm = this;

      return db
        .collection("gallery")
        .doc(this.$route.params.gallery_id)
        .set(vm.gallery, { merge: true })
        .then(() => {
          this.media = {
            url: null,
            name: null,
            size: null,
            date: null,
            usage_count: null,
            tags: []
          };
          this.showDialog = false;
        })
        .then(() => {
          return Swal.fire("Success", "Page Updated", "success");
        })
        .catch(err => {
          return Swal.fire(
            "Error",
            "Your file couldn't be uploaded, Try again later",
            "warning"
          );
        });
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.media_dialog {
  width: 800px;
  overflow-y: auto;
  height: 600px;
}

.md-dialog {
  max-width: 768px;
}

.tabs {
  margin-top: 5%;
}
</style>
